import React from "react";
import { useParams, Navigate, useLocation } from "react-router-dom";

export default function AssessRedirect() {
  const { slug } = useParams();
  const loc = useLocation();
  const target = (slug ? `/c/${slug}` : "/c") + (loc.search || "") + (loc.hash || "");
  return <Navigate to={target} replace />;
}
